// extracted by mini-css-extract-plugin
export default {"watch":"_3SFDJ","record":"_1zOL8","buttonContainer":"_1lyvv","desktopButtonContainer":"_10Sct","paidProgramPrice":"dWQSv"};